import { LOGIN_TYPE } from '@constants/navigation'

export const isLoginType = (type) => type === LOGIN_TYPE
